import type { ReactNode } from "react";
import { createContext, useContext } from "react";

import { useMe } from "@/api/hooks";
import type { AdminResponse } from "@/api/types";

interface AuthContextValue {
	admin: AdminResponse | null;
	isLoading: boolean;
	isAuthenticated: boolean;
}

const AuthContext = createContext<AuthContextValue | undefined>(undefined);

export function AuthProvider({ children }: { children: ReactNode }) {
	const meQuery = useMe();
	const value: AuthContextValue = {
		admin: meQuery.data ?? null,
		isLoading: meQuery.isLoading,
		isAuthenticated: Boolean(meQuery.data),
	};
	return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth(): AuthContextValue {
	const ctx = useContext(AuthContext);
	if (!ctx) {
		throw new Error("useAuth must be used within <AuthProvider>");
	}
	return ctx;
}
